import { css } from 'styled-components';
import { LandingPageProps } from './models';

export const viewWrapper = css`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 0 20px 20px;
  justify-content: center;
`;

export const LandingPage = css<LandingPageProps>(({ theme }) => {
  return css`
    overflow-y: auto;
    display: flex;
    flex: 1 0 0;
    position: relative;
    flex-direction: column;
    padding-top: 40px;

    @media only screen and ${theme.device.mobileXL} {
      padding-top: 58px;
    }
  `;
});
